@for (button of buttons(); track button; let first = $first) {
  @if (!button.hidden) {
    @switch (isTypedButton(button) && button.btnType) {
      @case ('edit') {
        <ng-container
          [ngTemplateOutlet]="editButton"
          [ngTemplateOutletContext]="{ button, first }"
        ></ng-container>
      }
      @default {
        <ng-container
          [ngTemplateOutlet]="customButton"
          [ngTemplateOutletContext]="{ button, first }"
        ></ng-container>
      }
    }
  }
}

<ng-template
  #editButton
  let-button="button"
  let-first="first"
>
  <allianz-edit-button
    [ngClass]="button.class"
    [class.nx-margin-left-2xs]="!first"
    [attr.data-testid]="button.testId"
    [disabled]="button.disabled"
    [nxButtonType]="button.nxButtonType"
    [action]="button.action"
  ></allianz-edit-button>
</ng-template>

<ng-template
  #customButton
  let-button="button"
  let-first="first"
>
  <allianz-button
    [ngClass]="button.class"
    [class.nx-margin-left-2xs]="!first"
    [type]="button.type"
    [icon]="button.icon"
    [label]="button.label"
    [testId]="button.testId"
    [nxButtonType]="button.nxButtonType"
    [disabled]="button.disabled"
    (click)="button.action?.()"
  >
  </allianz-button>
</ng-template>
